import {
  type SaveProductCtaText,
  type SaveProductEvent,
  buildSaveProductEvent,
} from './accountEmailEvents';

type SendSaveProductEvent = (event: SaveProductEvent) => unknown;

export const dispatchSaveProductEvent = (
  sendEvent: SendSaveProductEvent,
  ctaText: SaveProductCtaText
): void => {
  try {
    Promise.resolve(sendEvent(buildSaveProductEvent(ctaText))).catch(
      (): undefined => undefined
    );
  } catch {
    // Analytics must never interrupt the save or sign-in flow.
  }
};
